<template>
  <div>
    <h1>线下授课</h1>
    <div class="teach-list">
      <a-spin :spinning="loading">
        <div class="content">
          <div class="title">
            线下授课课程时间安排
          </div>

          <a-table
              class="teach-table"
              ref="table"
              size="middle"
              bordered
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              @change="handleTableChange">
          </a-table>
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'OfflineTeachTImeList',
  data() {
    return {
      dataSource: [],
      loading: true,
      ipagination: {
        current: 1,
        pageSize: 25,
        pageSizeOptions: ['15', '25', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      columns: [
        {
          align: 'center',
          title: '序号',
          width: 60,
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          align: 'center',
          title: '课程编码',
          width: 120,
          dataIndex: 'viewCode'
        },
        {
          align: 'center',
          title: '课程名称',
          width: 200,
          dataIndex: 'viewName'
        },
        {
          align: 'center',
          title: '授课教师',
          width: 150,
          dataIndex: 'teacherName'
        },
        {
          align: 'center',
          title: '授课日期',
          width: 150,
          dataIndex: 'teachDate'
        },
        {
          align: 'center',
          title: '开始时间',
          width: 150,
          dataIndex: 'startTime'
        },
        {
          align: 'center',
          title: '结束时间',
          width: 150,
          dataIndex: 'endTime'
        }
      ]
    }
  },
  created() {
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    getDataList() {
      let pageNo = this.ipagination.current
      let pageSize = this.ipagination.pageSize
      this.axios.get(`biz/home/offlineteach/list?pageNo=${pageNo}&pageSize=${pageSize}`).then(res => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.loading = false
        } else {
          this.dataSource = []
        }
      })
    },
    handleTableChange(pagination, filters, sorter) {
      this.ipagination = pagination
      this.getDataList()
    }
  }
}
</script>
<style scoped>
h1 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.teach-list {
  padding: 24px;
  background-color: #fff;
  min-height: 400px;
}
.title {
  background: #f8faf9;
  font-size: 16px;
  padding: 12px 0;
  text-align: center;
  margin-bottom: 24px;
}
.teach-table {
  /*background-color: #eaeaea;*/
}
.ant-table-body >>> tr td{
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/offlineteach/components/TeachTimePageList.vue